import { QuerifyService } from '@core/services/querify.service';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { Queries } from './queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./queries";
import * as i3 from "../../services/querify.service";
var EquipmentsApi = /** @class */ (function () {
    function EquipmentsApi(apollo, queries, querify) {
        this.apollo = apollo;
        this.queries = queries;
        this.querify = querify;
    }
    EquipmentsApi.prototype.getEquipments = function (query, options) {
        options = this.querify.transformOptions(query, options);
        return this.apollo
            .query({
            query: this.queries.getEquipments(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['equipments'];
        }));
    };
    EquipmentsApi.prototype.searchOne = function (id) {
        return this.apollo
            .query({
            query: this.queries.getEquipment(),
            variables: { id: id }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['equipment'];
        }));
    };
    EquipmentsApi.prototype.getFiltersData = function () {
        return this.apollo
            .query({
            query: this.queries.getFiltersData()
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data;
        }));
    };
    EquipmentsApi.prototype.searchEquipmentType = function (query) {
        var options = this.querify.transformOptions(query);
        return this.apollo
            .query({
            query: this.queries.getEquipmentsTypes(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['equipmentsTypes'];
        }));
    };
    EquipmentsApi.prototype.searchOneEquipmentType = function (id) {
        return this.apollo
            .query({
            query: this.queries.getEquipmentType(),
            variables: { id: id }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['equipmentType'];
        }));
    };
    EquipmentsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EquipmentsApi_Factory() { return new EquipmentsApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries), i0.ɵɵinject(i3.QuerifyService)); }, token: EquipmentsApi, providedIn: "root" });
    return EquipmentsApi;
}());
export { EquipmentsApi };
